// Create the main myMSALObj instance
// configuration parameters are located at authConfig.js
import {msalConfig, loginRequest, tokenRequest} from './authConfig.js';


const myMSALObj = new msal.PublicClientApplication(msalConfig);

let username = "";

function selectAccount() {

    /**
     * See here for more info on account retrieval: 
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
     */

    const currentAccounts = myMSALObj.getAllAccounts();
    if (currentAccounts.length === 0) {
        return;
    } else if (currentAccounts.length > 1) {
        // Add choose account code here
        console.warn("Multiple accounts detected.");
    } else if (currentAccounts.length === 1) {
        username = currentAccounts[0].username;
        console.log("selectAccount",username);
        //showWelcomeMessage(username);
    }
}

function handleResponse(response) {

    /**
     * To see the full list of response object properties, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#response
     */

    if (response !== null) {
        username = response.account.username;
        localStorage.setItem('nombreUsr', response.account.name);
        getTokenPopup(tokenRequest)
            .then(resp => {
                localStorage.setItem('id_token', resp.accessToken);
                if (window.opener && !window.opener.closed) {
                    //window.opener.postMessage('authenticated', window.location.origin);
                    window.close(); // Cierra la ventana emergente.
                }
            }).catch(error => {
                console.error(error);
            });
    } else {
        selectAccount();
    }
}

async function signIn() {
    /**
     * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
     */
    
    
    return new Promise((resolve, reject) => {
        myMSALObj.loginPopup(loginRequest)
          .then(handleResponse)
          .then(() => {
            resolve(); // Resuelve la promesa cuando la autenticación es exitosa
          })
          .catch(error => {
            reject(error); // Rechaza la promesa si hay un error en la autenticación
          });
      });

/*
    myMSALObj.loginPopup(loginRequest)
        .then(handleResponse)
        .catch(error => {
            console.error(error);
        });
        */
}

function signOut() {

    /**
     * You can pass a custom request object below. This will override the initial configuration. For more information, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/request-response-object.md#request
     */

    const logoutRequest = {
        account: myMSALObj.getAccountByUsername(username),
        //postLogoutRedirectUri: msalConfig.auth.redirectUri,
        //mainWindowRedirectUri: msalConfig.auth.redirectUri
        mainWindowRedirectUri: process.env.REDIRECTLOGOUT
    };

    myMSALObj.logoutPopup(logoutRequest);
    
}

function getTokenPopup(request) {

    /**
     * See here for more info on account retrieval: 
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-common/docs/Accounts.md
     */
    request.account = myMSALObj.getAccountByUsername(username);
    
    return myMSALObj.acquireTokenSilent(request)
        .catch(error => {
            console.warn("silent token acquisition fails. acquiring token using popup");
            if (error instanceof msal.InteractionRequiredAuthError) {
                // fallback to interaction when silent call fails
                return myMSALObj.acquireTokenPopup(request)
                    .then(tokenResponse => {
                        console.log(tokenResponse);
                        return tokenResponse;
                    }).catch(error => {
                        console.error(error);
                    });
            } else {
                console.warn(error);   
            }
    });
}

//function seeProfile() {
//    getTokenPopup(loginRequest)
//        .then(response => {
//            callMSGraph(graphConfig.graphMeEndpoint, response.accessToken, updateUI);
//        }).catch(error => {
//            console.error(error);
//        });
//}



function seetoken() {
    getTokenPopup(tokenRequest)
        .then(response => {
            console.log(response.accessToken);
        }).catch(error => {
            console.error(error);
        });
}

//selectAccount();
export {signIn, signOut};